import React from "react";
import DataGridComponent from "Utils/Constants/DataGridComponent";
import { usersList } from "Utils/Helpers/TableColumns";

export default function UsersTable({ data }) {
  return <DataGridComponent data={data} columns={usersList} rowHeight={75} />;
}
